import { createCookieForHours } from '../components/common/Cookie';

export const getAffiliatePayload = () => {
  if (typeof window === 'undefined' || !window.location) return null;
  const params = new URLSearchParams(window.location.search);

  const utmMedium = params.get('utm_medium');

  // Only proceed if channel is affiliate or creator
  if (utmMedium !== 'affiliate' && utmMedium !== 'creator') return null;

  params.delete('utm_medium');
  // Build correct URL with ?
  const newUrl = `${window.location.pathname}?${params.toString()}`;

  // Update URL without reload
  window.history.replaceState({}, document.title, newUrl);
  return {
    attributed_affiliate_name: params.get('utm_source'),
    attributed_affiliate_id: params.get('pid'),
    attributed_affiliate_campaign_id: params.get('offer_id'),
    attributed_affiliate_click_id: params.get('clickid'),
    attributed_affiliate_sub_id: 'NA',
    attributed_affiliate_additional_publisher_info: params.get('utm_term'),
    attributed_affiliate_campaign_medium: utmMedium,
    attributed_affiliate_campaign_name: params.get('utm_campaign')
  };
};

export const getAffiliateCookie = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null;
  const cookie = document.cookie.split('; ').find(c => c.startsWith('affiliate_tracking='));
  const params = new URLSearchParams(window?.location?.search);

  const utmMedium = params.get('utm_medium');
  if (utmMedium?.length > 0 && utmMedium !== 'affiliate' && utmMedium !== 'creator') return null;
  if (!cookie) return null;

  try {
    return JSON.parse(decodeURIComponent(cookie.split('=')[1]));
  } catch {
    return null;
  }
};

export const setAffiliateCookie = (affiliateFeatureConfig = {}, creatorprogramconfig = {}) => {
  if (typeof window !== 'undefined' && window.location) {
    const utmMedium = new URLSearchParams(window.location.search).get('utm_medium');
    if (utmMedium && utmMedium !== 'affiliate') {
      createCookieForHours('affiliate_tracking', '', -1);
      return;
    }
  }

  const newData = getAffiliatePayload();

  if (newData) {
    const oldData = getAffiliateCookie('affiliate_tracking');
    const medium = newData.attributed_affiliate_campaign_medium;
    const attributionWindow =
      medium === 'creator'
        ? creatorprogramconfig?.creatorAttributionWindow || 0
        : affiliateFeatureConfig?.attributionWindow || 24;
    if (!oldData) {
      // First affiliate/creator click
      createCookieForHours(
        'affiliate_tracking',
        encodeURIComponent(JSON.stringify(newData)),
        attributionWindow
      );
    } else if (oldData.attributed_affiliate_id !== newData.attributed_affiliate_id) {
      // Different affiliate/creator → overwrite
      createCookieForHours(
        'affiliate_tracking',
        encodeURIComponent(JSON.stringify(newData)),
        attributionWindow
      );
    }
    // Same affiliate/creator → keep old cookie
  }
};
